import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useState } from 'react';
var AiWidgetConfigContext = /*#__PURE__*/createContext(null);

/**
 * Provides the `AiWidgetConfigContext` value to the children
 * Value is stored on initial render, so if you change the value, updating the props will not update the context value
 */
export var AiWidgetConfigProvider = function AiWidgetConfigProvider(_ref) {
  var supportWidgetConfig = _ref.supportWidgetConfig,
    children = _ref.children;
  var _useState = useState({
      supportWidgetConfig: supportWidgetConfig
    }),
    _useState2 = _slicedToArray(_useState, 1),
    value = _useState2[0];
  return /*#__PURE__*/React.createElement(AiWidgetConfigContext.Provider, {
    value: value
  }, children);
};

/**
 * Provides the `AiWidgetConfigContext` value if it exists, otherwise return null
 * Use this hook if you want to access the `AiWidgetConfigContext` value in a component
 * but have a fallback behaviour if its missing
 */
export var useOptionalAiWidgetConfig = function useOptionalAiWidgetConfig() {
  return useContext(AiWidgetConfigContext);
};

/**
 * Provides the `AiWidgetConfigContext` value if it exists, otherwise throws an error
 * Use this hook if you need to access the `AiWidgetConfigContext` value in a component
 * and should fail fast if its missing
 */
export var useAiWidgetConfig = function useAiWidgetConfig() {
  var contextValue = useContext(AiWidgetConfigContext);
  if (!contextValue) {
    throw new Error('useSuppportWidgetConfig must be used within a AiWidgetConfigProvider');
  }
  return contextValue;
};